<script setup>
  import { useI18n } from 'vue-i18n';
  import Popup from '@/components/controls/Popup.vue';
  import Icon from "@/components/icons/Icon.vue";

  const { t } = useI18n();

  const props = defineProps({
    itemId: {
      type: [Number, String],
      required: true
    },
    hideActions: {
      type: Array,
      default: () => []
    }
  });

  const emit = defineEmits(['rename', 'copy', 'move', 'delete']);

  function handleActionClick(action) {
    emit(action);
  }
</script>

<template>
  <Popup
    :id="`menu-${props.itemId}`"
    icon="more-menu"
  >
    <template #button-content>
      <div class="jwx-popup__button">
        <Icon name="more-menu" class="jwx-table-view__row-action" />
        <span class='sr-only'>{{ t('containers.section.openActionsMenu') }}</span>
      </div>
    </template>
    <template #menu-content>
      <div class="jwx-popup-menu">            
        <div class="jwx-action-menu">
          <ul class="jwx-action-menu__list">
            <li v-if="!props.hideActions.includes('rename')" class="jwx-action-menu__action">
              <button 
                type="button"
                @click.prevent="handleActionClick('rename')"
                class="jwx-action-menu__action-button"
              >
                <Icon name="edit" class="jwx-action-menu__action-icon" />
                <span class=jwx-action-menu__action-label>{{ t('common.rename') }}</span>
              </button>
            </li>
            <li v-if="!props.hideActions.includes('copy')" class="jwx-action-menu__action">
              <button 
                type="button"
                @click.prevent="handleActionClick('copy')" 
                class="jwx-action-menu__action-button"
              >
                <Icon name="duplicate" class="jwx-action-menu__action-icon" />
                <span class=jwx-action-menu__action-label>{{ t('common.copy') }}</span>
              </button>
            </li>
            <li v-if="!props.hideActions.includes('move')" class="jwx-action-menu__action">
              <button 
                type="button"
                @click.prevent="handleActionClick('move')" 
                class="jwx-action-menu__action-button"
              >
                <Icon name="move-to" class="jwx-action-menu__action-icon" />
                <span class=jwx-action-menu__action-label>{{ t('common.move') }}</span>
              </button>
            </li>
            <li v-if="!props.hideActions.includes('delete')" class="jwx-action-menu__action">
              <button 
                type="button"
                @click.prevent="handleActionClick('delete')"
                class="jwx-action-menu__action-button"
              >
                <Icon name="trash" class="jwx-action-menu__action-icon" />
                <span class=jwx-action-menu__action-label>{{ t('common.delete') }}</span>
              </button>
            </li>
          </ul>
        </div>
      </div>
    </template>
  </Popup>
</template>